import GenericHero from "../../components/GenericHero/GenericHero";
import Heading from "../../components/Heading/Heading";
import "./ServicesPage.scss";
import serviceImg from "../../assets/images/services.svg";
import whoImg from "../../assets/images/composer.svg";
import whyImg from "../../assets/images/standing.svg";
import Button from "../../components/Button/Button";
import ServiceCard from "../../components/ServiceCard/ServiceCard";

export default function ServicesPage() {
  return (
    <div className="servicesPage">
      <GenericHero
        hAlt="Vector image of a man selecting service boxes."
        hImg={serviceImg}
        head="Services"
        btn2Content="Request a Quote"
        btn2Link="#contact"
        btnContent="View Services"
        btnLink="#services"
        text="Need a website facelift, a custom database, or help establishing your online presence? You bring the vision, and I’ll handle the rest- turning your ideas into a product that fits your style and exceeds expectations."
      />
      <ul className="servicesPage__services" id="services">
        <ServiceCard
          title="Consultation"
          content="I will review your current website, study your approach, goals, and vision, and offer advice on how to improve your website to meet your objectives."
        />
        <ServiceCard
          title="Web Design & Mockup"
          content="I will collaborate with you to create a design language and mockup that aligns with your goals and vision for your business."
        />
        <ServiceCard
          title="Responsive Web Development"
          content="I will build your website from the ground up, ensuring that the final product is responsive and accessible on all devices."
        />
        <ServiceCard
          title="Web Hosting"
          content="I offer web hosting at little to no cost, depending on the size of your project."
        />
        <ServiceCard
          title="Website Maintenance"
          content="After your website is finished, I offer maintenance services to ensure there are no bugs or issues. If any arise, I will respond quickly and efficiently to fix them."
        />
        <ServiceCard
          title="Training & Support"
          content="For more intensive projects that require a learning curve, I offer training and support to ensure you know how to use the system completely."
        />
        <ServiceCard
          title="SEO Friendly Development"
          content="By following SEO best practices, I will ensure that your website is optimized for search engines and can be easily found."
        />
        <ServiceCard
          title="API Integration"
          content="If your project requires integration with other services, I can integrate any API you need to provide the full flexibility and functionality you expect."
        />
      </ul>
      <section className="servicesPage__who">
        <Heading content="Who Am I" />
        <div className="servicesPage__content">
          <section className="servicesPage__container">
            <p className="servicesPage__text">
              Hello! I am Zea (pronounced Zee-Aye), a freelance web developer
              based in Northwest Arkansas. My journey into web development began
              after graduating college during the pandemic. Searching for a new
              path, I was drawn to technology. After months of prayer and
              deliberating, I took the leap to enroll in a bootcamp, graduated,
              and started building websites for clients while honing my skills.
            </p>
            <p className="servicesPage__text">
              Before web development, I had a background in music performance. I
              played bass for my church every week and took every opportunity to
              perform wherever I could. Through music, I developed the
              discipline to see projects though to the smallest detail-- because
              just like in a song, every element of a website matters. I now
              bring that same creativity and precision to web development.
            </p>
            <p className="servicesPage__text">
              I’m passionate about building websites and digital products that
              are tailored to my clients’ needs and values. I’m always eager to
              take on new challenges, grow my expertise, and make something
              excellent with each project.
            </p>
          </section>
          <section className="servicesPage__wrapper">
            <img
              src={whoImg}
              alt="A man playing guitar."
              className="servicesPage__img servicesPage__img--who"
            />
          </section>
        </div>
      </section>
      <section className="servicesPage__why">
        <Heading content="Why Me" />
        <div className="servicesPage__content">
          <section className="servicesPage__container">
            <p className="servicesPage__text">
              Your website is more than just a digital presence—it’s a
              reflection of your values, mission, and identity. That’s why I
              approach every project with care, tailoring solutions to your
              unique needs and goals. I strive to create websites that are not
              only functional but also true to who you are.
            </p>
            <p className="servicesPage__text">
              When working with me, I will provide clear and consistent
              communication every step of the way. I take the time to understand
              your vision and keep you informed every step of the way, so that
              we’re always on the same page.
            </p>
            <p className="servicesPage__text">
              My faith drives me to deliver high-quality work with each project
              I take on. I see my work as a reflection of my values, and I’m
              dedicated to delivering websites that are thoughtfully made,
              functional, and aligned with your goals.
            </p>
            <p className="servicesPage__text">
              You can count on me to stay organized, work hard from start to
              finish, and guide your project to completion with professionalism
              and care.
            </p>
          </section>
          <section className="servicesPage__wrapper">
            <img
              src={whyImg}
              alt="A man standing looking to the left."
              className="servicesPage__img servicesPage__img--why"
            />
          </section>
        </div>
      </section>
      <section className="servicesPage__cta">
        <p className="servicesPage__call">
          Ready to make your online vision an online reality?
        </p>
        <a href="#contact">
          <Button content="Let's Get Started" classtitle="button button__cta" />
        </a>
      </section>
    </div>
  );
}
